<header class="basic-header">
  <div class="basic-header__container container">
    <a
      class="basic-header__logo"
      [routerLink]="homeLink"
      [attr.aria-label]="'a11y.header.logo.link' | translate"
    >
      <app-logo [name]="logo" height="30" [alt]="logoAlt"></app-logo>
    </a>
  </div>
</header>
